import React, { useState, useEffect } from 'react';
import api from '../services/api';

interface LeadFiltersProps {
  onFilterChange: (filters: { consultor?: number; status?: string; telefone?: string }) => void;
}

interface Consultor {
  id: number;
  name: string;
}

const LeadFilters: React.FC<LeadFiltersProps> = ({ onFilterChange }) => {
  const [consultores, setConsultores] = useState<Consultor[]>([]);
  const [selectedConsultor, setSelectedConsultor] = useState<string>('');
  const [selectedStatus, setSelectedStatus] = useState<string>('');
  const [telefone, setTelefone] = useState<string>('');

  useEffect(() => {
    fetchConsultores();
  }, []);

  const fetchConsultores = async () => {
    try {
      const response = await api.get('/users/consultores');
      setConsultores(response.data);
    } catch (error) {
      console.error('Erro ao buscar consultores:', error);
    }
  };

  const handleConsultorChange = (value: string) => {
    setSelectedConsultor(value);
    applyFilters(value, selectedStatus, telefone);
  };

  const handleStatusChange = (value: string) => {
    setSelectedStatus(value);
    applyFilters(selectedConsultor, value, telefone);
  };

  const handleTelefoneChange = (value: string) => {
    setTelefone(value);
    // Aplica o filtro imediatamente quando o usuário digita
    applyFilters(selectedConsultor, selectedStatus, value);
  };

  const applyFilters = (consultor: string, status: string, phone: string) => {
    const filters: { consultor?: number; status?: string; telefone?: string } = {};
    
    if (consultor) {
      filters.consultor = parseInt(consultor);
    }
    
    if (status) {
      filters.status = status;
    }
    
    if (phone && phone.trim()) {
      filters.telefone = phone.trim();
    }
    
    onFilterChange(filters);
  };

  const clearFilters = () => {
    setSelectedConsultor('');
    setSelectedStatus('');
    setTelefone('');
    onFilterChange({});
  };

  return (
    <div className="bg-white p-4 rounded-lg shadow mb-6">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Filtrar por Consultor
          </label>
          <select
            value={selectedConsultor}
            onChange={(e) => handleConsultorChange(e.target.value)}
            className="w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
          >
            <option value="">Todos os consultores</option>
            {consultores.map((consultor) => (
              <option key={consultor.id} value={consultor.id}>
                {consultor.name}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Filtrar por Status
          </label>
          <select
            value={selectedStatus}
            onChange={(e) => handleStatusChange(e.target.value)}
            className="w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
          >
            <option value="">Todos os status</option>
            <option value="novo">Novo</option>
            <option value="contato_inicial">Contato Inicial</option>
            <option value="em_negociacao">Em Negociação</option>
            <option value="proposta_enviada">Proposta Enviada</option>
            <option value="fechado_ganho">Fechado Ganho</option>
            <option value="fechado_perdido">Fechado Perdido</option>
            <option value="arquivado">Arquivado</option>
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Buscar por Telefone
          </label>
          <input
            type="text"
            value={telefone}
            onChange={(e) => handleTelefoneChange(e.target.value)}
            placeholder="Digite o número de telefone"
            className="w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
          />
        </div>

        <div className="flex items-end">
          <button
            onClick={clearFilters}
            className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 transition-colors"
          >
            Limpar Filtros
          </button>
        </div>
      </div>
    </div>
  );
};

export default LeadFilters;